// extracted by mini-css-extract-plugin
export default {"filesList":"FilesList_filesList__dNLEs","itemData":"FilesList_itemData__Mk8A8","fa":"FilesList_fa__9yJsf"};